export default "__VITE_ASSET__OuJI8W60__"